<template>
	<div id="Index">
		<!-- <h1 style="text-align:center; color: rgb(255, 255, 255);">服务器维护中请耐心等待</h1> -->
		<!-- <nav-header></nav-header> -->
 
		<div class="out-bj">
			<keep-alive>
				<router-view id=""></router-view>
			</keep-alive>
		</div> 
        <public-footer></public-footer>
	</div>
</template>

<script>
	//import NavHeader from '@/components/common/NavHeader/NavHeader.vue'
	import PublicFooter from '@/components/common/PublicFooter/PublicFooter.vue'
import { Image } from 'element-ui';
	export default{
		name:'Index',
		data(){
			return{
				
			}
		},
		methods:{
			
		},
		components:{
			//NavHeader,
			PublicFooter
		}
	}
</script>
<style lang="scss">
 #Index{
		 //background:url(../../assets/images/public/mbg.gif);
		 background-attachment:fixed;
		 background-position: top;
		 background-size: 100% 100%;
		 overflow-x: hidden;
         //background: #15172c;
	 .out-bj{
		 width: 100%;
         height: 100%;

            img 
            {
                width: 100%;
                height: 100%;
            }
	 }
	 
	 .el-backtop{
		 background: #15172c;
		 i{
			 color: #fff;
		 }
	 }
     #output{
          width: 1400px;
		  padding-bottom: 160px;
          margin: 0 auto;

     }
 
     .Tips {
         text-align: center;
         color: #2a9fd6;
         font-size: 0.14rem;
         line-height: 0.5rem;
         cursor: pointer;
         &:hover {
             color: #2fc8ff;
        }
    }
}
</style>
